import { Map, Polygon, YMaps } from '@pbe/react-yandex-maps';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { MOGILEV_REGION_COORDS } from '../../shared/constants/mogilevRegion';
import { useData } from '../../shared/hooks/use-data';
import { CustomBalloon } from './custom-balloon/custom-balloon';
import { StyledMapContainer } from './custom-map.style';
import CustomPlacemark from './custom-placemark/custom-placemark';
import { useTheme } from 'styled-components';

export const CustomMap = () => {
    const { data, selectedDataItem, setSelectedDataItem } = useData();

    const { colors } = useTheme();

    const apiKey = "12720a83-f9bc-4ff8-87dc-6749c7bb4b5f"; //где хранить апи? в env?

    const [position, setPosition] = useState<{ x: number; y: number }>(null);

    const mapRef = useRef<any>(null);

    const updatePosition = useCallback(() => {
        if (selectedDataItem && mapRef.current) {
            const coords = [selectedDataItem.lat, selectedDataItem.lon];
            const projection = mapRef.current.options.get('projection');
            const zoom = mapRef.current.getZoom();

            const globalPixels = projection.toGlobalPixels(coords, zoom);
            const pagePixels = mapRef.current.converter.globalToPage(globalPixels);

            const mapElement = mapRef.current.container.getElement();
            const rect = mapElement.getBoundingClientRect();

            const x = pagePixels[0] - rect.left - window.scrollX;
            const y = pagePixels[1] - rect.top - window.scrollY;

            const estimatedCardHeight = 360;

            if (y < estimatedCardHeight) {
                setIsBottom(true);
            } else {
                setIsBottom(false);
            }

            setPosition({ x, y });
        }
    }, [selectedDataItem]);

    useEffect(() => {
        updatePosition();
    }, [updatePosition]);

    const queryProps = useMemo(() => {
        return { apikey: apiKey, lang: 'ru_RU' } as any
    }, [])

    const [isBottom, setIsBottom] = useState(false);

    const options = useMemo(() => {
        const { danger, primaryMedium } = colors;

        return {
            strokeColor: danger,
            strokeWidth: 2,
            strokeOpacity: 0.8,

            fillColor: primaryMedium,
            fillOpacity: 0.3,

            interactive: false,
        }
    }, [colors]);

    const onMapClick = (): void => {
        setSelectedDataItem(null);

        setPosition(null);
    }

    const placemarks = useMemo(() => {
        return data.map((item, index) => {
            return <CustomPlacemark item={item} key={index} />
        })
    }, [data]);

    const balloon = useMemo(() => {
        if (position && selectedDataItem) {
            return <CustomBalloon position={position} isBottom={isBottom} />
        }
    }, [position, selectedDataItem, isBottom]);

    return (
        <StyledMapContainer $width="70%">
            <YMaps query={queryProps}>
                <Map
                    defaultState={{
                        margin: [0, 0, 0, 0],
                        bounds: [
                            [52.9, 27.9],
                            [54.30, 32.85],
                        ],
                        zoom: 10,
                    }}
                    instanceRef={mapRef}
                    onBoundsChange={updatePosition}
                    onActionTick={updatePosition}
                    width="100%"
                    height="100%"
                    onClick={onMapClick}
                >
                    <Polygon
                        geometry={[MOGILEV_REGION_COORDS]}
                        options={options}
                    />

                    {placemarks}
                </Map>
            </YMaps>

            {balloon}
        </StyledMapContainer >
    )
}